module.exports = __webpack_public_path__ + "static/img/hover-iocn62.10945c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn62.png
// module id = j6Fc
// module chunks = 1